var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharePopover',[_c('a',{staticClass:"tw-text-primary",attrs:{"title":_vm.$t('share'),"tabindex":"0"}},[_c('fa',{staticClass:"hover-darken cursor-pointer",attrs:{"icon":_vm.icons.shareAlt}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }